<template>
  <base-page-template>
    <template #toolbar-items>
      <el-tooltip content="新規サイト追加" placement="bottom">
        <v-btn icon @click="openCreateDialog">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </el-tooltip>

      <v-toolbar-title class="with-divider">
        サイト管理
      </v-toolbar-title>
    </template>

    <terminal-table
      :terminals="terminals"
      @openDeleteDialog="openDeleteDialog"
      @openUpdateDialog="openUpdateDialog"
      @openCredentialDownloadDialog="openCredentialDownloadDialog">
    </terminal-table>

    <!-- 作成ダイアログ -->
    <simple-dialog
      v-model="dialogCreate.visible"
      title-text="サイト作成"
      @close="closeCreateDialog"
      @apply="createTerminal">

      <terminal-form
        v-model="dialogCreate.form">
      </terminal-form>
    </simple-dialog>

    <!-- 更新ダイアログ -->
    <simple-dialog
      v-model="dialogUpdate.visible"
      title-text="サイト編集"
      @close="closeUpdateDialog"
      @apply="updateTerminal">

      <terminal-form
        v-model="dialogUpdate.form">
      </terminal-form>
    </simple-dialog>

    <!-- 削除ダイアログ -->
    <simple-dialog
        v-model="dialogDelete.visible"
        title-text="サイト削除"
        title-color="delete"
        apply-text="削除"
        header-text="以下のサイトを削除します。本当によろしいですか？"
        @close="closeDeleteDialog"
        @apply="deleteTerminal">

      <terminal-form
        v-model="dialogDelete.form"
        readonly>
      </terminal-form>
    </simple-dialog>

    <!-- 認証ファイルダウンロードダイアログ -->
    <simple-dialog
        v-model="dialogCredentialDownload.visible"
        title-text="認証ファイルダウンロード"
        apply-text="ダウンロード"
        header-text="連携ターミナルの認証用ファイルをダウンロードします。"
        @close="closeCredentialDownloadDialog"
        @apply="downloadCredentialFile">
    </simple-dialog>
  </base-page-template>
</template>

<script>
import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
import IoablePageMixin from "@/router/IoablePageMixin";
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import TerminalTable from "@/components/pages/admin/TerminalList/TerminalTable.vue";
import TerminalForm from "@/components/pages/admin/TerminalList/TerminalForm.vue";
import FileUtils from "@/utils/FileUtils";

export default {
  name: 'TerminalList',
  components: {
    BasePageTemplate,
    SimpleDialog,
    TerminalTable,
    TerminalForm
  },
  mixins: [
    IoablePageMixin,
    FileUtils
  ],
  computed: {
    ...mapState('hcs/terminal', ['terminals']),
    ...mapGetters({
      account: 'hcs/account'
    }),
  },
  data() {
    return {
      dialogCreate: {
        visible: false,
        from: {}
      },
      dialogUpdate: {
        visible: false,
        from: {}
      },
      dialogDelete: {
        visible: false,
        from: {}
      },
      dialogCredentialDownload: {
        visible: false,
        from: {}
      },
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar',
      setLoginUser: 'hcs/setLoginUser',
    }),
    ...mapActions({
      load: 'hcs/terminal/findList'
    }),
    openCreateDialog() {
      this.dialogCreate = {
        visible: true,
        form: this.defaultForm()
      };
    },
    closeCreateDialog() {
      this.dialogCreate.visible = false;
    },
    openUpdateDialog(terminal) {
      this.dialogUpdate = {
        visible: true,
        form: { ...terminal }
      }
    },
    closeUpdateDialog() {
      this.dialogUpdate.visible = false;
    },
    openDeleteDialog(terminal) {
      this.dialogDelete = {
        visible: true,
        form: { ...terminal }
      }
    },
    closeDeleteDialog() {
      this.dialogDelete.visible = false;
    },
    openCredentialDownloadDialog(terminal) {
      this.dialogCredentialDownload = {
        visible: true,
        form: { ...terminal }
      }
    },
    closeCredentialDownloadDialog() {
      this.dialogCredentialDownload.visible = false;
    },
    defaultForm() {
      return {
        name: '',
        description: '',
        pollingRate: 10,
        publishing: true
      }
    },
    createTerminal() {
      this.showSnackbar({
        message: 'サイトを作成中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/terminal/create', this.dialogCreate.form)
          .then(terminal => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `サイトの作成に成功しました`
            });
          })
          .catch(() => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `サイトの作成に失敗しました`
            });
          });
    },
    updateTerminal() {
      this.showSnackbar({
        message: 'サイトを更新中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/terminal/update', this.dialogUpdate.form)
        .then(terminal => {
          if(terminal.id === this.account.user?.terminal.id) {
            this.account.user.terminal = terminal;
            this.setLoginUser({loginUser: this.account.user});
          }

          this.$store.commit({
            type: 'showSnackbar',
            message: `サイトの更新に成功しました`
          });
        })
        .catch(() => {
          this.$store.commit({
            type: 'showSnackbar',
            color: 'failed',
            message: `サイトの更新に失敗しました`
          });
        });
    },
    deleteTerminal() {
      this.showSnackbar({
        message: 'サイトを削除中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/terminal/delete', this.dialogDelete.form.id)
        .then(() => {
          this.$store.commit({
            type: 'showSnackbar',
            message: `サイトの削除に成功しました`
          });
        })
        .catch(() => {
          this.$store.commit({
            type: 'showSnackbar',
            color: 'failed',
            message: `サイトの削除に失敗しました`
          });
        })
    },
    downloadCredentialFile() {
      this.$store.dispatch('hcs/terminal/fetchDockerFile', this.dialogCredentialDownload.form.id)
        .then((response) => {
          this.downloadFile(response, 'docker-compose.yml')
        })
       .catch(() => {
         this.$store.commit({
           type: 'showSnackbar',
           color: 'failed',
           message: `認証ファイルのダウンロードに失敗しました`
         });
       })
    }
  }
}
</script>
